// src/components/SplashScreen.tsx

import React from "react";

import "./SplashScreen.css";

import logo from "../assets/images/logos/p-arena-logo.png";


// =====================================================
// TYPES
// =====================================================

interface SplashScreenProps {
  visible: boolean;
  text?: string;
}


// =====================================================
// SAFARI DETECTION
// =====================================================
//
// iPhone/iPad Safari can produce a temporary white
// rectangle when a transparent PNG is animated using
// blur/filter + transform + opacity together.
//
// We only use this flag to give Safari a safer logo
// animation. Other browsers keep the existing effect.
// =====================================================

const isSafariBrowser = (): boolean => {

  if (typeof navigator === "undefined") {
    return false;
  }

  const ua =
    navigator.userAgent;

  const vendor =
    navigator.vendor || "";

  const isAppleDevice =
    /iPad|iPhone|iPod/.test(ua);

  const isSafari =
    /Safari/i.test(ua) &&
    /Apple/i.test(vendor) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);

  return (
    isAppleDevice &&
    isSafari
  );
};


// =====================================================
// SPLASH SCREEN
// =====================================================

const SplashScreen: React.FC<SplashScreenProps> = ({
  visible,
  text = "ENTERING THE ARENA",
}) => {

  if (!visible) {
    return null;
  }

  const safari =
    isSafariBrowser();

  return (
    <div
      className={
        safari
          ? "splash-screen splash-screen-safari"
          : "splash-screen"
      }
    >

      <div className="splash-content">

        {/* ========================================= */}
        {/* P-ARENA LOGO                              */}
        {/* ========================================= */}

        <img
          src={logo}
          alt="P-Arena"
          className="splash-logo"
          draggable={false}
        />


        {/* ========================================= */}
        {/* LOADING BAR                               */}
        {/* ========================================= */}

        <div className="splash-loader">

          <div className="splash-loader-bar" />

        </div>


        {/* ========================================= */}
        {/* LOADING TEXT                              */}
        {/* ========================================= */}

        <p className="splash-text">
          {text}
        </p>

      </div>

    </div>
  );
};


export default SplashScreen;
